import React, { useState, useContext, useEffect } from "react";
import { Row, Col, Button, Tag, Progress, Alert } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import BillingFeature from "../../Billing/BillingFeature";
import { RootContext } from "../../../RootContextProvider";
import { Link } from "react-router-dom";
import { getCurrentPlan, getPercentUsage } from "../../../utils/utils";
import { fetchCustomerPortalSession } from "../../../utils/stripe";

const AdminSubscription = () => {
  let history = useHistory();
  const { account, listPages } = useContext(RootContext);

  const [loading, setLoading] = useState(true);
  const [loadingPortal, setLoadingPortal] = useState(false);
  const [currentPlan, setCurrentPlan] = useState();

  useEffect(() => {
    const loadPlan = () => {
      setCurrentPlan(
        account.IsPaying ? getCurrentPlan(account.PlanID) : "GRATUIT"
      );
      setLoading(false);
    };

    loadPlan();

    // eslint-disable-next-line
  }, []);

  const handleClickPaid = async () => {
    if (!account.CustomerID || !account.IsPaying) {
      history.push("/billing");
    } else {
      setLoadingPortal(true);
      let portalURL = await fetchCustomerPortalSession(account.CustomerID);
      console.log(portalURL);
      setLoadingPortal(false);
      window.location.replace(portalURL.url);
    }
  };

  // const handleDeleteSub = async () => {

  // }

  if (loading) {
    return <></>;
  } else {
    return (
      <>
        {account.IsPaying && account.CancelSubAt ? (
          <Alert
            message={`Votre compte restera actif jusqu'au
        ${new Date(account.CancelSubAt * 1000).toLocaleDateString(
          "fr-FR"
        )}. À la suite
        de ce jour, vous n'aurez plus accès premium aux fonctionnalités de Linksight.`}
            type="warning"
            showIcon
          />
        ) : (
          ""
        )}
        <Row gutter={20}>
          <Col xl={16} ml={16} sm={24} xs={24}>
            <div className="block-section">
              <Row className="container-settings" style={{ marginTop: "20px" }}>
                <Col xl={16} ml={16} sm={24} xs={24}>
                  <div className="third-title social">
                    Details de votre abonnement
                  </div>
                  <div className="tag-plan">
                    <Tag
                      color="#A7A9D6"
                      style={{
                        fontSize: "15px",
                        height: "35px",
                        lineHeight: "35px",
                      }}
                    >
                      {currentPlan}
                    </Tag>
                  </div>
                  <div className="page-count">
                    <span>
                      {listPages.length} / {account.Limitations} page
                      {account.Limitation === 1 ? "" : "s"}
                    </span>
                    <Progress
                      percent={getPercentUsage(
                        listPages.length,
                        account.Limitations
                      )}
                      showInfo={false}
                    />
                  </div>
                  <div className="more">
                    {!account.IsPaying
                      ? "Changez de plan pour profiter de toutes les fonctionnalités."
                      : ""}
                    <br />
                    <Link to="/billing">
                      En savoir plus sur les différents tarifs.
                    </Link>
                  </div>
                </Col>
                <Col xl={8} ml={8} sm={24} xs={24}>
                  <div className="current-price"></div>
                  {account.Admin ? (
                    <div className="upgrade-btn">
                      <Button
                        className="submit-link"
                        htmlType="submit"
                        loading={loadingPortal}
                        onClick={() => {
                          handleClickPaid();
                        }}
                        size="large"
                      >
                        {account.CustomerID ? (
                          "Gérer mon abonnement"
                        ) : (
                          <>
                            Passez au plan premium <ArrowRightOutlined />
                          </>
                        )}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </div>
          </Col>
          <Col xl={8} ml={8} sm={24} xs={24}>
            {currentPlan.includes("Premium") ? (
              <div className="block-section">
                <div className="third-title" style={{ marginTop: "10px" }}>
                  <span role="img" aria-label="check">
                    🤙
                  </span>{" "}
                  Passez au plan Agence et obtenez :
                </div>
                <BillingFeature
                  hasFeature={true}
                  detail="50 pages personnalisables"
                />
                <BillingFeature hasFeature={true} detail="Liens illimités" />
                <BillingFeature
                  hasFeature={true}
                  detail="Support prioritaire"
                />
                <BillingFeature hasFeature={true} detail="Et bien plus..." />
              </div>
            ) : currentPlan.includes("Agence") ? (
              <div className="block-section">
                <div className="third-title" style={{ marginTop: "10px" }}>
                  <span role="img" aria-label="check">
                    🤙
                  </span>{" "}
                  Linksight vous permet de bénéficier de :
                </div>
                <BillingFeature
                  hasFeature={true}
                  detail="50 pages personnalisables"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Support prioritaire"
                />

                <BillingFeature hasFeature={true} detail="Et bien plus..." />
              </div>
            ) : (
              <div className="block-section">
                <div className="third-title" style={{ marginTop: "10px" }}>
                  <span role="img" aria-label="check">
                    🤙
                  </span>{" "}
                  Passez au plan Premium et obtenez :
                </div>
                <BillingFeature
                  hasFeature={true}
                  detail="5 pages personnalisables"
                />
                <BillingFeature hasFeature={true} detail="Liens illimités" />
                <BillingFeature
                  hasFeature={true}
                  detail="Statistiques sur vos liens"
                />
                <BillingFeature
                  hasFeature={true}
                  detail="Pas de logo Linksight"
                />
                <BillingFeature hasFeature={true} detail="Et bien plus..." />
              </div>
            )}
          </Col>
        </Row>
        {/* <div className="block-container">
          {" "}
          <div className="danger-zone-section" style={{ marginTop: "30x" }}>
            <div className="secondary-title red">Danger zone</div>

            <Button
              onClick={() => {
                handeDeleteSub()
              }}
              style={{ width: "fit-content" }}
              type="danger"
              className="danger-btn"
            >
              Annuler mon abonnement Linksight
            </Button>
          </div>
        </div> */}
      </>
    );
  }
};
export default AdminSubscription;
